import HomeCollectionHeader from './HomeCollectionHeader';

export default HomeCollectionHeader;
